import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://zzftuwmixtlkaiqqqsva.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp6ZnR1d21peHRsa2FpcXFxc3ZhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTgwMDEwOTcsImV4cCI6MjAzMzU3NzA5N30.i8MNXkRb6QCURQ0potWIbxD9Z8rh3XaGYogjtew2fkc';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);


